import { useState, useRef } from "react"

import Style from "./style"
import pwHide from "./asset/pwHide.svg"
import pwShow from "./asset/pwShow.svg"

import usePostAdmin from "entity/auth/usePostAdmin"
import usePostUtilSms from "entity/util/usePostUtilSms"
import usePostUtilSmsConfirm from "entity/util/usePostUtilSmsConfirm"

import DefaultButton from "shared/ui/DefaultButton"
import DefaultInput from "shared/ui/DefaultInput"
import useConfrimCookie from "shared/model/useConfrimCookie"
import { useEffect } from "react"

const SignupAdmin = () => {

    const [isPwShow, setIsPwShow] = useState(false)

    const idRef = useRef()
    const pwRef = useRef()
    const nameRef = useRef()
    const contactRef = useRef()
    const confirmRef = useRef()

    const [sendState, sendEvent] = usePostUtilSms(contactRef)
    const [confirmEvent] = usePostUtilSmsConfirm(contactRef, confirmRef)
    const [postAdmin] = usePostAdmin(idRef, pwRef, nameRef)

    const [confirmCookie, , deleteConfirmCookie] = useConfrimCookie()

    useEffect(() => {
        return () => {
            deleteConfirmCookie()
        }
    }, [])

    return (
        <Style.Wrapper>
            <Style.ContentDiv>
                <h2>관리자 회원가입</h2>

                <Style.FormDiv>
                    <DefaultInput label="아이디" inputRef={idRef} placeholder="20글자 이하" />
                    <Style.PasswordContainer>
                        <DefaultInput label="비밀번호" type={isPwShow ? "text" : "password"} inputRef={pwRef} placeholder="비밀번호를 입력해주세요">
                            <button onClick={() => setIsPwShow(state => !state)}>
                                <img src={isPwShow ? pwShow : pwHide} />
                            </button>
                        </DefaultInput>
                        <Style.PasswordGuide>• 6자 이상, 20자 이하</Style.PasswordGuide>
                        <Style.PasswordGuide>• 영문, 숫자, 특수문자를 모두 포함</Style.PasswordGuide>
                    </Style.PasswordContainer>
                    <DefaultInput label="이름" inputRef={nameRef} placeholder="20글자 이하 | 한글과 영문만 가능" />
                    <DefaultInput label="연락처" inputRef={contactRef} placeholder="'-' 없이 숫자만 입력">
                        <DefaultButton small fitWidth clickEvent={sendEvent} deactive={confirmCookie}>인증번호 받기</DefaultButton>
                    </DefaultInput>
                    {sendState &&
                        <div>
                            <DefaultInput label="인증번호" inputRef={confirmRef} placeholder="6글자의 숫자만 입력">
                                <DefaultButton small fitWidth clickEvent={confirmEvent} deactive={confirmCookie}>인증하기</DefaultButton>
                            </DefaultInput>
                            {confirmCookie && <Style.Guide>인증되었습니다.</Style.Guide>}
                        </div>
                    }
                </Style.FormDiv>

                <Style.BtnDiv>
                    <DefaultButton clickEvent={postAdmin}>회원가입</DefaultButton>
                </Style.BtnDiv>

            </Style.ContentDiv>
        </Style.Wrapper>
    )
}

export default SignupAdmin